import * as I18n from 'i18n-js';
import * as React from 'react';

const classNames = require('classnames');

interface Props {
  title: string;
  href: string;
  backgroundImage: string;
  narrow?: boolean;
}

export default class CalloutEmbed extends React.Component<Props, null> {
  render() {
    const classes = classNames(
      'callout-embed',
      { 'callout-embed--narrow': this.props.narrow },
    );

    return (
      <div
        className={classes}
        style={{ backgroundImage: `url(${this.props.backgroundImage})` }}
      >
        <a href={this.props.href}>
          <h1 className="callout-embed__title">
            {this.props.title}
          </h1>
          <div className="callout-embed__action">
            {I18n.t('discovery.calloutEmbed.shopNow')}
          </div>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/embeds/callout_embed.tsx